

const MasterScreenReducer = (state = {}, action) => {
    switch (action.type) {
        case "getExceptionListSuccess": {
            return Object.assign({}, state, {
                ExceptionList: action.data,
            });
            break;
        }
        case "ExceptionDetail": {
            return Object.assign({}, state, {
                ExceptionDetail: action.data,
            });
            break;
        }
        //Exist Keyword screen
        case "getKeywordLineItemsListSuccess": {
            return Object.assign({}, state, {
                KeywordLineItemsList: action.data,
            });
            break;
        }

        case "getKeywordListSuccess": {
            return Object.assign({}, state, {
                KeywordList: action.data,
            });
            break;
        }
        case "KeywordDetail": {
            return Object.assign({}, state, {
                KeywordDetail: action.data,
            });
            break;
        }
        case "getStaffInfoListSuccess": {
            return Object.assign({}, state, {
                StaffInfoList: action.data,
            });
            break;
        }
        case "getFleetManagerInfoListSuccess": {
            return Object.assign({}, state, {
                FleetManagerInfoList: action.data,
            });
            break;
        }
        case "getTechExecutiveInfoListSuccess": {
            return Object.assign({}, state, {
                TechExecutiveInfoList: action.data,
            });
            break;
        }
        case "getTechSuperintendentInfoListSuccess": {
            return Object.assign({}, state, {
                TechSuperintendentInfoList: action.data,
            });
            break;
        }
        case "getFleetManagerArrayListSuccess": {
            return Object.assign({}, state, {
                FleetManagerArrayList: action.data,
            });
            break;
        }
        case "StaffDetails": {
            return Object.assign({}, state, {
                StaffDetails: action.data,
            });
            break;
        }
        case "getClientListSuccess": {
            return Object.assign({}, state, {
                ClientList: action.data,
            });
            break;
        }
        case "getClientUsersListSuccess": {
            return Object.assign({}, state, {
                clientUserList: action.data,
            });
            break;
        }
        case "ClientUserDetails": {
            return Object.assign({}, state, {
                ClientUserDetails: action.data,
            });
            break;
        }
        case "ClientDetails": {
            return Object.assign({}, state, {
                ClientDetails: action.data,
            });
            break;
        }

        case "FleetClientDetails": {
                return Object.assign({}, state, {
                    FleetClientDetails: action.data,
                });
                break;
        }
        case "ExecutiveClientDetails": {
            return Object.assign({}, state, {
            ExecutiveClientDetails: action.data,
            });
            break;
        }
            case "SuperintendentClientDetails": {
                return Object.assign({}, state, {
                    SuperintendentClientDetails: action.data,
                });
                break;
            }
        case "getShipManagementListSuccess": {
            return Object.assign({}, state, {
                ShipList: action.data,
            });
            break;
        }
        case "getShipManagementDetailSuccess": {
            return Object.assign({}, state, {
                ShipDetails: action.data,
            });
            break;
        }
        case "getCertificateSuccess": {
            return Object.assign({}, state, {
                CertificateDetails: action.data,
            });
            break;
        }
        case "getLRFormSuccess": {
            return Object.assign({}, state, {
                LRForm: action.data,
            });
            break;
        }
        case "getLRFormPDFSuccess": {
            return Object.assign({}, state, {
                LRFormPDF: action.data,
            });
            break;
        }
        case "getInventoryPersonSuccess": {
            return Object.assign({}, state, {
                InventoryPerson: action.data,
            });
            break;
        }
        case "AttachmentUploadHKCSuccess": {
            return Object.assign({}, state, {
                HKCAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadEUSSRSuccess": {
            return Object.assign({}, state, {
                EUSSRAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadFullManualSuccess": {
            return Object.assign({}, state, {
                FullManualAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadFlagSOCSuccess": {
            return Object.assign({}, state, {
                FlagSOCAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadIAPPSuccess": {
            return Object.assign({}, state, {
                IAPPAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadampSuccess": {
            return Object.assign({}, state, {
                AMPAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadldafdSuccess": {
            return Object.assign({}, state, {
                LDSFAAttachment: action.data,
            });
            break;
        }
        case "AttachmentUploadecSuccess": {
            return Object.assign({}, state, {
                ECAttachment: action.data,
            });
            break;
        }
        case "GetPaintCoatingList": {
            return Object.assign({}, state, {
                PaintCoatingList: action.data,
            });
            break;
        }
        case "GetEquipmentMachineryList": {
            return Object.assign({}, state, {
                EquipmentMachineryList: action.data,
            });
            break;
        }
        case "GetStructureHullList": {
            return Object.assign({}, state, {
                StructureHullList: action.data,
            });
            break;
        }
        case "GetStoreList": {
            return Object.assign({}, state, {
                StoreList: action.data,
            });
            break;
        }
        case "EditMaterial": {
            return Object.assign({}, state, {
                EditMaterial: action.data,
            });
            break;
        }
        case "GetPaintCoatingDetails": {
            return Object.assign({}, state, {
                PaintCoatingDetails: action.data,
            });
            break;
        }
        case "GetEquipmentMachineryDetails": {
            return Object.assign({}, state, {
                EquipmentMachineryDetails: action.data,
            });
            break;
        }
        case "GetStructureHullDetails": {
            return Object.assign({}, state, {
                StructureHullDetails: action.data,
            });
            break;
        }
        case "GetStoreDetails": {
            return Object.assign({}, state, {
                StoreDetails: action.data,
            });
            break;
        }
        case "EditUser": {
            return Object.assign({}, state, {
                editUser: action.data,
            });
            break;
        }
        case "GetFleetManagerDetails": {
            return Object.assign({}, state, {
                fleetManagerDetail: action.data,
            });
            break;
        }
        case "GetTechSuperintendentDetails": {
            return Object.assign({}, state, {
                TechSuperintendentDetail: action.data,
            });
            break;
        }
        case "GetTechExecutiveDetails": {
            return Object.assign({}, state, {
                TechExecutiveDetail: action.data,
            });
            break;
        }
        case "GetFleetManagerlist": {
            return Object.assign({}, state, {
                fleetManagerlist: action.data,
            });
            break;
        }
        case "GetTechSuperintendentlist": {
            return Object.assign({}, state, {
                TechSuperintendentlist: action.data,
            });
            break;
        }
        case "GetTechExecutivelist": {
            return Object.assign({}, state, {
                TechExecutivelist: action.data,
            });
            break;
        }
        case "getCompanyListSuccess": {
            return Object.assign({}, state, {
                CompanyNames: action.data.companyName,
            });
            break;
        }
        case "getCompanyUsersListSuccess": {
            return Object.assign({}, state, {
                CompanyUsers: action.data,
            });
            break;
        }
        case "CompanayName": {
            return Object.assign({}, state, {
                CompanyName: action.data,
            });
            break;
        }
        case 'pagenumber': {
            return Object.assign({}, state, {
                pagesearch: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }
};
export default MasterScreenReducer;
